exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom {\n  padding-top: 22px; }\n\n.panel {\n  box-shadow: none;\n  margin-bottom: auto; }\n\n.added-block {\n  padding: 5px 0px; }\n\n.img-thumbnail {\n  border: 0 !important;\n  padding: 0;\n  border-radius: 0; }\n\n/* custon file upload */\ninput[type=\"file\"] {\n  display: block;\n  color: transparent; }\n\n.fileUpload {\n  position: relative;\n  overflow: hidden;\n  margin: 10px; }\n\n.fileUpload input.upload {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  font-size: 20px;\n  cursor: pointer; }\n\n.choose-btn {\n  padding: 5px 15px; }\n\n.s-n-btn {\n  margin-right: 1.3em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/menu-items/add-item/add-item.component.scss
// module id = ../../../../../src/app/routes/restaurant/menu-items/add-item/add-item.component.scss
// module chunks = main